import { contactInfo } from "@/mocks/site";
import SubscribeForm from "./SubscribeForm";

export default function ContactSection() {
  return (
    <div id="subscribe" className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
      <div className="lg:col-span-5">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
          <i className="ri-message-3-line text-sm"></i>
          联系我们
        </span>
        <h2 className="mt-4 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          有故事想分享，或者想加入我们？
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          如果你发现了值得围观的现场，或者觉得某条评论特别有料，欢迎通过下面的方式告诉我们。
          我们也在招募内容整理志愿者，负责每天挑选和核实热评。
        </p>

        <dl className="mt-6 flex flex-col gap-4">
          {contactInfo.map((item) => (
            <div key={item.label} className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <dt className="text-xs font-semibold text-foreground-500">{item.label}</dt>
                <dd className="mt-1 break-words text-sm font-medium text-foreground-900">{item.value}</dd>
              </div>
            </div>
          ))}
        </dl>
      </div>

      <div className="lg:col-span-7">
        <SubscribeForm />
      </div>
    </div>
  );
}